<template>
  <div>
      <iframe name="iframe1" :srcdoc="isHttp ? null : $store.state.iframeURL" :src="isHttp ? $store.state.iframeURL : null" class="iframe-style"></iframe>
  </div>
</template>
<script>

export default {
async mounted() {
  if (!this.$store.state.iframeURL) {
    this.$router.push('/home');
  }
},
computed: {
  // http(s) and blob: (HTML converted to blob URL, e.g. PGSoft) use src;
  // raw HTML from other callers still uses srcdoc
  isHttp() {
    const url = this.$store.state.iframeURL || '';
    return url.startsWith('http') || url.startsWith('blob:');
  }
}
};
</script>
<style scoped>
.iframe-style {
  width: 100vh; 
  height: 100vh; 
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 10000;
  background: #04090A !important;
}
</style>
